import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

const setSmsSettingsCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("SET_SMS_SETTINGS_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    smsProviderName: z.enum(["twilio", "46elks", "test"]).default("46elks"),
    smsAuthProviderName: z.enum(["twilio", "46elks", "test"]).default("46elks"),
    regexPhoneNumberBlocks: z.array(z.string()).optional(),
    blockedCountryCodes: z.array(z.string()).optional(),
});
type SetSmsSettingsCommand = z.infer<typeof setSmsSettingsCommandZodObject>;
const setSmsSettingsCommandZodScheme =
    setSmsSettingsCommandZodObject as z.ZodSchema<SetSmsSettingsCommand>;

const _factoryParamsZodObject = setSmsSettingsCommandZodObject.omit({
    _id: true,
    _type: true,
    _createdAt: true,
});
type FactoryParams = z.infer<typeof _factoryParamsZodObject>;
const setSmsSettingsCommandFactory = (params: FactoryParams) => {
    const command: SetSmsSettingsCommand = {
        ...params,
        _id: generateId({ prefix: "set_sms_settings_command__" }),
        _type: "SET_SMS_SETTINGS_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

export {
    setSmsSettingsCommandFactory,
    _factoryParamsZodObject as setSmsSettingsCommandFactoryParamsZodObject,
    setSmsSettingsCommandZodObject,
    setSmsSettingsCommandZodScheme,
};
export type {
    SetSmsSettingsCommand,
    FactoryParams as SetSmsSettingsCommandFactoryParams,
};
